<div class="uk-container">
	<div class="ServicesHeading">
		<div class="ServicesHeading_Title">
			<h1>Сравнение товаров</h1>
		</div>
	</div>
</div>

<div *ngIf="items.length === 0 && !loadingState" class="uk-container">
	<div class="uk-alert-warning" uk-alert>
		<h3>Нет товаров для сравнения</h3>
	</div>
</div>

<div *ngIf="items.length > 0" class="uk-container">
	<div class="uk-overflow-auto uk-position-relative">
		<table id="Compare" class="Compare uk-table">
			<thead>
			<tr uk-height-match="target: > th > div">
				<th>
					<div class="CompareFilter">
						<span class="CompareFilter_Title">
							<h3 class="uk-width-1-1 uk-margin-remove">Списки товаров</h3>
						</span>

						<div class="CompareFilter_Body">
							<div class="uk-position-relative uk-width-1-1">
								<ng-template [ngIf]="lists.length > 0">
									<select class="uk-select" name="filterLists" [(ngModel)]="filterList" (change)="changeList()">
										<option *ngFor="let list of lists" [value]="list">{{ list }}</option>
									</select>

									<span *ngIf="lists.length > 1" class="CompareFilter_Remove uk-link" (click)="removeList()">
										<span class="IconItem IconItem--close">
											<img src="/assets/img/icon/close.svg" uk-svg>
										</span>
										Удалить список
									</span>
								</ng-template>

								<div class="CompareFilter_Mode">
									<label class="uk-position-relative uk-flex uk-flex-middle">
										<input type="radio" value="all" [(ngModel)]="compareMode" (change)="changeMode('all')">
										<span class="RadioFlag"></span>
										<span>Все параметры</span>
									</label>

									<label class="uk-position-relative uk-flex uk-flex-middle">
										<input type="radio" value="differ" [(ngModel)]="compareMode" (change)="changeMode('differ')">
										<span class="RadioFlag"></span>
										<span>Различающиеся</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</th>

				<th *ngFor="let item of items; let i = index">
					<div class="CatalogCard">
						<a class="uk-display-block" [routerLink]="['/catalog', item.CODE || item.ID ]">
							<!-- <span class="CatalogCard_Title">
								<span class="uk-h3 uk-width-1-1 uk-margin-remove">{{item.IBLOCK_SECTION.NAME}}</span>
							</span> -->
							<span class="CatalogCard_Img">
								<img *ngIf="item.PREVIEW_PICTURE" [src]="item.PREVIEW_PICTURE.SRC" [alt]="item.PREVIEW_PICTURE.DESCRIPTION || item.NAME">
								<span *ngIf="!item.PREVIEW_PICTURE" class="uk-h3 uk-margin-remove">Нет фото</span>
							</span>
						</a>
						<div class="CatalogCard_Bottom">
							<a class="CatalogCard_Description" [routerLink]="['/catalog', item.CODE || item.ID]">{{item.NAME}}</a>

							<a class="CatalogCard_Price" [routerLink]="['/catalog', item.CODE || item.ID]">
								<ng-template [ngIf]="item.BASE_PRICE.PRICE">{{item.BASE_PRICE.PRICE | currency: item.BASE_PRICE.CURRENCY : 'symbol' :'1.0-0'}}</ng-template>
		                        <ng-template [ngIf]="!item.BASE_PRICE.PRICE">Нет цены</ng-template>
							</a>

							<span class="CatalogCard_Remove" (click)="removeFromCompare(item, i)">
								<span class="IconItem IconItem--close">
									<img src="/assets/img/icon/close.svg" uk-svg>
								</span>
								Удалить
							</span>
						</div>
					</div>
				</th>
			</tr>
			</thead>
			<tbody class="Compare_Params" *ngIf="items[0].PROPERTIES">
				<tr>
					<td [attr.colspan]="items.length + 1"><h3>Основные характеристики</h3></td>
				</tr>

				<tr *ngFor="let prop of items[0].PROPERTIES; let propIndex = index"
					class="Compare_Param"
					[ngClass]="{'Compare_Param--equal': isEqualProp(propIndex), 'Compare_Param--differ': compareMode === 'differ'}"
				>
					<td><strong>{{prop.NAME}}</strong></td>
					<td *ngFor="let item of items">{{item.PROPERTIES[propIndex].VALUE}}</td>
				</tr>
			</tbody>
		</table>

		<div id="CompareHeadFixed" class="CompareHeadFixed">
			<div class="uk-grid">
				<div>
					<div class="CompareFilter">
						<span class="CompareFilter_Title">
							<h3 class="uk-width-1-1 uk-margin-remove">Списки товаров</h3>
						</span>

						<div class="CompareFilter_Body">
							<div class="uk-position-relative uk-width-1-1">
								<ng-template [ngIf]="lists.length > 0">
									<select class="uk-select" name="filterLists" [(ngModel)]="filterList" (change)="changeList()">
										<option *ngFor="let list of lists" [value]="list">{{ list }}</option>
									</select>

									<span *ngIf="lists.length > 1" class="CompareFilter_Remove uk-link" (click)="removeList()">
										<span class="IconItem IconItem--close">
											<img src="/assets/img/icon/close.svg" uk-svg>
										</span>
										Удалить список
									</span>
								</ng-template>

								<div class="CompareFilter_Mode">
									<label class="uk-position-relative uk-flex uk-flex-middle">
										<input type="radio" value="all" [(ngModel)]="compareMode" (change)="changeMode('all')">
										<span class="RadioFlag"></span>
										<span>Все параметры</span>
									</label>

									<label class="uk-position-relative uk-flex uk-flex-middle">
										<input type="radio" value="differ" [(ngModel)]="compareMode" (change)="changeMode('differ')">
										<span class="RadioFlag"></span>
										<span>Различающиеся</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div *ngFor="let item of items; let i = index">
					<div class="CatalogCard CatalogCard--small">
						<a class="uk-display-block" [routerLink]="['/catalog', item.CODE || item.ID]">
							<!-- <span class="CatalogCard_Title">
								<span class="uk-h3 uk-width-1-1 uk-margin-remove">{{item.IBLOCK_SECTION.NAME}}</span>
							</span> -->
							<span class="CatalogCard_Img">
								<img *ngIf="item.PREVIEW_PICTURE" [src]="item.PREVIEW_PICTURE.SRC" [alt]="item.PREVIEW_PICTURE.DESCRIPTION || item.NAME">
								<span *ngIf="!item.PREVIEW_PICTURE" class="uk-h3 uk-margin-remove">Нет фото</span>
							</span>
						</a>
						<div class="CatalogCard_Bottom">
							<a class="CatalogCard_Description" [routerLink]="['/catalog', item.CODE || item.ID]">{{item.NAME}}</a>

							<a class="CatalogCard_Price" [routerLink]="['/catalog', item.CODE || item.ID]">
								<ng-template [ngIf]="item.BASE_PRICE.PRICE">{{item.BASE_PRICE.PRICE | currency: item.BASE_PRICE.CURRENCY : 'symbol' :'1.0-0'}}</ng-template>
				                <ng-template [ngIf]="!item.BASE_PRICE.PRICE">Нет цены</ng-template>
							</a>

							<span class="CatalogCard_Remove" (click)="removeFromCompare(item, i)">
								<span class="IconItem IconItem--close">
									<img src="/assets/img/icon/close.svg" uk-svg>
								</span>
								Удалить
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
